import React, { Component } from 'react';
import { Printer, Envelope } from './icons';
import { I18n, translate } from 'react-i18next';
import ReactGA from 'react-ga';
import { parse } from 'qs';
import EmailForm from './EmailForm';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { showEmailForm: false };
    this.query = parse(window.location.search.replace('?', ''));
    this.hideLogo = this.query.logo === 'false' || false;
    this.toggleEmailForm = this.toggleEmailForm.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.header !== this.props.header) {
      this.setState({ showEmailForm: false });
    }
  }

  toggleEmailForm(show) {
    this.setState({ showEmailForm: show });
  }

  render() {
    return (
      <I18n ns="translations">
        {(t) => (
          <section className="header">
            <div className="container">
              <div className="header__logo-holder">
                {!this.hideLogo && <img className="logo" src="images/logo.png" alt="logo" />}
                {this.props.header === 'results' && (
                  <div className="header__actions">
                    <button
                      className="header__action"
                      onClick={() => {
                        window.print();
                        ReactGA.event({
                          category: this.props.i18n.language,
                          action: this.props.selectedFamily,
                          label: 'Print',
                        });
                      }}
                    >
                      <Printer size="16px" /> {t('header.actions.print')}
                    </button>
                    <button
                      className="header__action"
                      onClick={() => {
                        this.toggleEmailForm(!this.state.showEmailForm);
                        ReactGA.event({
                          category: this.props.i18n.language,
                          action: this.props.selectedFamily,
                          label: 'Share',
                        });
                      }}
                    >
                      <Envelope size="20px" /> {t('header.actions.share')}
                    </button>
                  </div>
                )}
              </div>
              <div className="text-content">
                <h2
                  dangerouslySetInnerHTML={{ __html: t('header.' + this.props.header + '.title') }}
                />
                {this.props.header !== 'results' ? (
                  <p>{t('header.' + this.props.header + '.copy')} <span>V 1.1</span></p>
                ) : (
                  ''
                )}
              </div>
            </div>
            {this.state.showEmailForm && <EmailForm />}
          </section>
        )}
      </I18n>
    );
  }
}

export default translate('translations')(Header);



// WEBPACK FOOTER //
// ./src/components/header.js